import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

export const formatReminderDate = (date: Date) =>
	dateFormatter(date, DateFormat.DisplaySpaced);
